<div [ngClass]="{ horizontal: isHorizontalOrientation() }">
	<color-circle
		[width]="horizontalWidth!"
		[colors]="colorPalette()"
		[color]="currentColor"
		(onChange)="onColorChange($event)"
	></color-circle>
	<hr />
	<div class="input-container">
		<input
			#color
			id="color"
			name="color"
			type="text"
			class="text colorInput"
			[required]="required()"
			[value]="currentColor"
			[maxLength]="maxLengthOfInput()"
			(paste)="onInputChange()"
			(input)="onInputChange()"
			(keydown)="onInputChange()"
			(blur)="onTouched()"
		/>
		<div
			class="currentSelectedColorCircle"
			[ngStyle]="{ 'box-shadow': currentColor + ' 0px 0px 0px 14px inset' }"
		></div>
	</div>
</div>
